/**
 * A custom element for the cinematic hero banner.
 *
 * Drives the circular scroll-progress ring and the "scroll to next section" button.
 * Text entrance animation is handled entirely in CSS.
 */
class AnimatedHero extends HTMLElement {
  connectedCallback() {
    this.progressRing = this.querySelector('.animated-hero__scroll-ring-progress');
    this.scrollButton = this.querySelector('.animated-hero__scroll-indicator');

    if (this.progressRing) {
      const radius = this.progressRing.r.baseVal.value;
      this.circumference = 2 * Math.PI * radius;
      this.progressRing.style.strokeDasharray = `${this.circumference}`;
      this.progressRing.style.strokeDashoffset = `${this.circumference}`;

      window.addEventListener('scroll', this.#updateProgress, { passive: true });
      this.#updateProgress();
    }

    this.scrollButton?.addEventListener('click', this.#scrollToNext);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#updateProgress);
  }

  #updateProgress = () => {
    const height = this.getBoundingClientRect().height || 1;
    const scrolled = Math.min(Math.max(-this.getBoundingClientRect().top, 0), height);
    const progress = scrolled / height;

    this.progressRing.style.strokeDashoffset = `${this.circumference * (1 - progress)}`;
  };

  #scrollToNext = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const currentSection = this.closest('.shopify-section');
    const next = currentSection?.nextElementSibling;

    next?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  };
}

if (!customElements.get('animated-hero')) {
  customElements.define('animated-hero', AnimatedHero);
}
